import { render } from "./MoneyTransfers.vue?vue&type=template&id=0af61c8f&ts=true"
import script from "./MoneyTransfers.vue?vue&type=script&lang=ts"
export * from "./MoneyTransfers.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\ulucefe\\source\\repos\\birimza.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__